import PCLNAnalytics from '@pcln/analytics'
import React, { memo } from 'react'
import { FilterHeader } from '../Shared/FilterHeader'
import { SliderSectionWrapper } from '../Slider.styles'
import { useStateProps, useTimeDispatch } from './Hooks'
import { TimeChips } from './TimeChips'

/**
 * Time Filters Component Using Hooks
 * @returns <TimeFilters/>
 */
function TimeFilters(props) {
  const { changeHandler } = props

  // Grab useful props from state
  const { activeTabId, time, lastReset, timeFilter, timebands } = useStateProps()

  // FROM API: New timebands logic
  const timeCategories = timeFilter?.[0]?.categories?.[0]
  const timebandsTakeoff = timeCategories?.takeoff?.timebands
  const timebandsLanding = timeCategories?.landing?.timebands

  // Handlers for time slider and reset button click
  const { handleTimeChipClick, resetHandler } = useTimeDispatch({
    changeHandler,
    activeTabId,
  })

  const sliceRefId = time?.[0]?.sliceRefId

  const takeoffTimeChips = (
    <TimeChips
      timebands={timebandsTakeoff}
      handleTimeChipClick={handleTimeChipClick}
      entity={'takeoff'}
      activeTimes={timebands}
      sliceRefId={sliceRefId}
    />
  )

  const landingTimeChips = (
    <TimeChips
      timebands={timebandsLanding}
      handleTimeChipClick={handleTimeChipClick}
      entity={'landing'}
      activeTimes={timebands}
      sliceRefId={sliceRefId}
    />
  )

  try {
    return (
      <SliderSectionWrapper key={lastReset}>
        <FilterHeader headerText={'Takeoff'} resetHandler={() => resetHandler('takeoff')} />
        {takeoffTimeChips}
        <FilterHeader headerText={'Landing'} resetHandler={() => resetHandler('landing')} />
        {landingTimeChips}
      </SliderSectionWrapper>
    )
  } catch (e) {
    PCLNAnalytics.logError({
      errorObject: e,
      message: 'Render Failure - File: TimeFilters.js: ' + e.stack,
      type: 'TimeFilters.js',
    })
    return null
  }
}

export default memo(TimeFilters)
